import styled from "styled-components";
import PlayButton from "public/assets/play-button.png";
import { breakpoints } from "styles/constants/breakpoints";
import { Container } from "styles/common/container";

export const AboutWrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.yellow["50"]};
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const AboutContainer = styled(Container)`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 54px;
  padding: 80px 0;
  @media ${breakpoints.mobile} {
    flex-direction: column-reverse;
    gap: 30px;
    padding: 40px 20px;
    width: 100%;
  }
`;

export const AboutTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 10 16px;
  position: relative;
  width: 600px;
`;

export const AboutText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 950px;

  .desc {
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
    text-align: left;
    @media ${breakpoints.mobile} {
      color: ${({ theme }) => theme.colors.neutral[700]};
      font-size: ${({ theme }) => theme.fontSizes["md"]};
      text-align: start;
      width: 350px;
      text-wrap: pretty;
      margin-left: 130px;
    }
  }
`;

export const AboutTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 24px;
  font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  font-weight: 700;
  margin: 0 0 16px;
  text-align: left;
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
    text-align: left;
    width: 360px;
    text-wrap: balance;
    margin-left: 130px;
    margin-bottom: 0;
  }
`;

export const AboutDesc = styled.div`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  text-align: left;
  @media ${breakpoints.mobile} {
    color: ${({ theme }) => theme.colors.neutral[700]};
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    text-align: start;
    width: 350px;
    text-wrap: pretty;
    margin-left: 130px;
  }
`;

export const AboutVideoThumbContainer = styled.div`
  position: relative;
  align-self: center;
  cursor: pointer;
  @media ${breakpoints.mobile} {
    width: 100%;
  }

  iFrame {
    border-radius: 4px;
    width: 410px;
    height: 230px;
  }

  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 64px;
    height: 64px;
    background: url(${PlayButton.src}) no-repeat center center;
    background-size: contain;
    border: none;
    cursor: pointer;
  }
`;

export const PlayButtonContainer = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  background: url(${PlayButton.src}) no-repeat center center;
  background-size: contain;
  border: none;
  cursor: pointer;
`;

export const VdoThumbnail = styled.div`
  width: 410px;
  height: 230px;
  background-size: cover;
  background-position: center;
  border-radius: 4px;
  @media ${breakpoints.mobile} {
    width: 100%;
    height: 190px;
  }
`;

export const AboutCTA = styled.a`
  display: flex;
  align-items: center;
  width: fit-content;
  text-align: center;
  cursor: pointer;
  gap: 8px;
  height: 36px;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.brand["500"]};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  text-decoration: none;
  border-radius: 6px;
  @media ${breakpoints.mobile} {
    margin-left: 130px;
    width: 300px;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
`;
